import cookies from 'js-cookie';
import PageComponent from '../component/page-component';

let embedExternalVideos = null;
// let isPaused = null;
// const autoplayCookieName = 'autoplayAnimations';
// const autoplay = cookies.get(autoplayCookieName);
// if (autoplay === '1') {
// 	isPaused = false;
// } else if (autoplay === '0') {
// 	isPaused = true;
// } else {
// 	const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
// 	isPaused = !mediaQuery || mediaQuery.matches;
// }
// cookies.set(autoplayCookieName, isPaused ? '0' : '1');

class VideoPlayerCover extends PageComponent {
	constructor({
		element,
		root,
		linkAttribute = 'videoLink',
		loadingClass = 'loading',
		loadedClass = 'loaded',
		embedExternalVideosClass = 'embedExternalVideos',
	} = {}) {
		super({element: element, root: root});
		this.defaults.linkAttribute = linkAttribute;
		this.loadingClass = loadingClass;
		this.loadedClass = loadedClass;
		this.embedExternalVideosClass = embedExternalVideosClass;
	}

	prepare() {
		const data = this.dataAttr().getAll();
		this.embedExternalVideosCookieName = data.embedExternalVideosCookieName;
		if (embedExternalVideos === null) {
			embedExternalVideos = +!!cookies.get(this.embedExternalVideosCookieName);
		}
		this.opened = false;
		this.link = this.element.querySelector(this.dataSelector(data.linkAttribute));
		this.player = this.getComponent('VideoPlayer');
		if (this.link && this.player) {
			this.listeners.click = this.events.on(this.element, this.dataSelector(data.linkAttribute), 'click', this.onClick.bind(this));
		} else {
			this.opened = true;
		}
		this.privacyToggler = this.getComponent('TogglerField');
		if (this.privacyToggler) {
			this.listeners.togglerChange = this.events.on(this.root, 'field:change', this.onPrivacyTogglerChange.bind(this));
		}
	}

	onClick(event) {
		if (event.button === 0 && !event.ctrlKey && !event.metaKey) {
			event.preventDefault();
			const classList = this.classList();
			classList.add(this.loadingClass);
			this.player.load().then(() => {
				classList.add(this.loadedClass);
				classList.remove(this.loadingClass);
			});
			this.opened = true;
		}
	}

	onPrivacyTogglerChange(event) {
		const component = event.detail.component;
		const owned = this.element.contains(component.getElement());
		const value = component.getValue();
		console.log('toggle', value, owned);
		if (owned) {
			embedExternalVideos = value;
			cookies.set(this.embedExternalVideosCookieName, embedExternalVideos);
		} else if (this.privacyToggler) {
			this.privacyToggler.setValue(value);
		}
		this.updateExternalVideosStatus(value);
	}

	updateExternalVideosStatus(value) {
		if (value || !this.opened) {
			this.classList().toggle(this.embedExternalVideosClass, value);
		}
	}
}

export default VideoPlayerCover;
